import React, { useEffect, useRef, useState } from 'react';

const TrustpilotCarousel = () => {
    const [isClient, setIsClient] = useState(false);
    const trustpilotWidgetRef = useRef(null);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (isClient && typeof window !== 'undefined' && window.Trustpilot && trustpilotWidgetRef.current) {
            window.Trustpilot.loadFromElement(trustpilotWidgetRef.current, true);
        }
    }, [isClient]);

    if (!isClient) {
        return null;
    }

    return (
        <div
            ref={trustpilotWidgetRef}
            className="trustpilot-widget bg-holborn-blue pt-12 pb-0 px-8 lg:px-0"
            data-locale="en-GB"
            data-template-id="539ad0ffdec7e10e686debd7"
            data-businessunit-id="58bff1ac0000ff00059e0e97"
            data-style-height="350px"
            data-style-width="100%"
            data-theme="dark"
            data-stars="4,5">
        </div>
    );
};

export default TrustpilotCarousel;